// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__30kWC","modalFooterButton":"ModalNotes_modalFooterButton__eaWHw"};